import type { VirtualAppointmentLoadStatus } from '@odo/shared-ui/clinical/virtualAppointments/types';

export interface VaTriggerGate {
    enabled: boolean;
    /** Why the action is disabled. */
    blockedReason?: string;
}

// Every VA action waits on the list: nothing is decidable until it loads.
export function loadStatusGate(status: VirtualAppointmentLoadStatus): VaTriggerGate | null {
    if (status === 'loading') return { enabled: false, blockedReason: 'Loading open VAs…' };
    if (status === 'error') {
        return { enabled: false, blockedReason: "Couldn't load the open VAs. Retry first." };
    }
    return null;
}

// Mirrors the backend guard on refinement/retention from a VA step, which stays the authority:
// every open VA must be resolved first; planned ones don't count.
export function vaTriggerGate(
    status: VirtualAppointmentLoadStatus,
    openCount: number
): VaTriggerGate {
    const loadGate = loadStatusGate(status);
    if (loadGate) return loadGate;
    if (openCount > 0) {
        return { enabled: false, blockedReason: `Resolve all open VAs first (${openCount} open)` };
    }
    return { enabled: true };
}
